import React, { Component } from "react";
import moment from "moment";
const $ = window.$;

export default class Datetimepicker extends Component {

    constructor(props) {
        super(props);
        this.state = { };


    }
    componentDidMount() {

        let self =this;
        //  $(function () {
             console.log("componentDidMount", self.props.value);
		    var d = new Date();
		    var toDay = d.getDate() + '/'
            + (d.getMonth() + 1) + '/'
            + (d.getFullYear() + 543);

				// Datepicker
             $("#datetimepicker-"+self.props.name).datepicker({ dateFormat: 'dd/mm/yy', isBuddhist: true, defaultDate: toDay, dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
              dayNamesMin: ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.'],
              monthNames: ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'],
              monthNamesShort: ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],
              onSelect: function (dateText) {
                    self.props.onSelect(dateText)
                    $("#datetimepicker-"+self.props.name).blur();
                    console.log('focusout')
                },
                autoClose: false,
                beforeShow:function(input, inst){$(this).css('color','#67676')},
                onClose:function(dateText, inst){$(this).css('color','black')}
            });
			  $("#datepicker-th-2").datepicker({ changeMonth: true, changeYear: true,dateFormat: 'dd/mm/yy', isBuddhist: true, showOn: 'button',buttonImage: '../DatePicker/calendar.png', buttonImageOnly: true, defaultDate: toDay,dayNames: ['อาทิตย์','จันทร์','อังคาร','พุธ','พฤหัสบดี','ศุกร์','เสาร์'],
              dayNamesMin: ['อา.','จ.','อ.','พ.','พฤ.','ศ.','ส.'],
              monthNames: ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม'],
              monthNamesShort: ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']});
			  $("#datepicker-en").datepicker({ dateFormat: 'dd/mm/yy'});
              $("#inline").datepicker({ dateFormat: 'dd/mm/yy', inline: true });
              
             $("#datetimepicker-" + self.props.name).datepicker("setDate", self.props.value);
            // });
            


    }

    componentWillReceiveProps(nextProps) { //moment
        let date = nextProps.value && (typeof nextProps.value === "string" || nextProps.value instanceof String) ? nextProps.value : [];
        if (nextProps.value !== this.props.value) {
            $("#datetimepicker-" + this.props.name).datepicker("setDate", nextProps.value);
        }
    }
    render() {
        let name = "datetimepicker-" + this.props.name;
        return <div>
            <input type="text" id={name}  className="ant-input"/>
            {/* readonly="readonly" */}
          </div>;
    }
}

// Datetimepicker.propTypes = {
//   name: PropTypes.string,
//   value: PropTypes.string,
//   onChange: PropTypes.func
// };


// AppButton.defaultProps = {
//     value: new Date(),
// };


// WEBPACK FOOTER //
// ./src/view/jquery/datetimepicker.js